import * as React from 'react'
import { Avatar, Divider, Typography } from 'antd'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

export const SplitHalf = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
`
export const SplitHalfToFrom = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
`
// LABEL-NBL
export const SplitImageInvoiceInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 16px;
`

const CenteredAvatar = styled(Avatar)`
  place-self: center;
`

type Props = {
  title?: React.ReactNode
  image?: React.ReactNode
  invoiceInfo?: React.ReactNode
  payer?: React.ReactNode
  company?: React.ReactNode
  items?: React.ReactNode
  discounts?: React.ReactNode
  description?: React.ReactNode
  total?: React.ReactNode
}

export default (p: Props) => (
  <>
    <Typography.Title>{p.title}</Typography.Title>
    <SplitImageInvoiceInfo>
      <CenteredAvatar src={p.image} shape="square" size={128} />
      {p.invoiceInfo}
    </SplitImageInvoiceInfo>
    <Divider />
    <SplitHalfToFrom>
      <div>
        <Typography.Title level={3}>
          <FormattedMessage id="to" />
        </Typography.Title>
        {p.payer}
      </div>
      <div>
        <Typography.Title level={3}>
          <FormattedMessage id="from" />
        </Typography.Title>
        {p.company}
      </div>
    </SplitHalfToFrom>
    <Divider />
    <div>
      <Typography.Title level={3}>
        <FormattedMessage id="items" />
      </Typography.Title>
      {p.items}
    </div>
    <Divider />
    <div>
      <Typography.Title level={3}>
        <FormattedMessage id="discounts" />
      </Typography.Title>
      {p.discounts}
    </div>
    <Divider />
    <SplitHalf>
      {p.description}
      {p.total}
    </SplitHalf>
  </>
)
